'use strict';

var _require = require('../../constants/image'),
    TRANSFORM_TYPE_FIT = _require.TRANSFORM_TYPE_FIT;

var _require2 = require('lodash'),
    min = _require2.min;

var blurParam = function blurParam(blur) {
  return blur > 0 ? 'blur_' + blur + ',' : '';
};

var getImageFilename = function getImageFilename(pathname) {
  return pathname ? pathname.replace(/^media\//, '') : '';
};

function getImageUrl(imageHost) {
  return function produceImage() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fileName = _ref.file_name,
        actualWidth = _ref.width,
        actualHeight = _ref.height;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$maxWidth = _ref2.maxWidth,
        maxWidth = _ref2$maxWidth === undefined ? 1000 : _ref2$maxWidth,
        _ref2$maxHeight = _ref2.maxHeight,
        maxHeight = _ref2$maxHeight === undefined ? 1000 : _ref2$maxHeight,
        _ref2$quality = _ref2.quality,
        quality = _ref2$quality === undefined ? 80 : _ref2$quality,
        _ref2$type = _ref2.type,
        type = _ref2$type === undefined ? TRANSFORM_TYPE_FIT : _ref2$type,
        _ref2$format = _ref2.format,
        format = _ref2$format === undefined ? 'png' : _ref2$format,
        _ref2$blur = _ref2.blur,
        blur = _ref2$blur === undefined ? 0 : _ref2$blur;

    if (fileName) {
      var _ref3 = [min([maxWidth, actualWidth]), min([maxHeight, actualHeight])],
          width = _ref3[0],
          height = _ref3[1];

      return 'https://' + imageHost + '/media/' + fileName + '/v1/' + type + '/w_' + width + ',h_' + height + ',' + blurParam(blur) + 'al_c,q_' + quality + '/file.' + format;
    }
    return '';
  };
}

module.exports = {
  getImageFilename: getImageFilename,
  getImageUrl: getImageUrl
};